import { render, staticRenderFns } from "./ShowCollege.vue?vue&type=template&id=77b92414&scoped=true"
import script from "./ShowCollege.vue?vue&type=script&lang=ts"
export * from "./ShowCollege.vue?vue&type=script&lang=ts"
import style0 from "./ShowCollege.vue?vue&type=style&index=0&id=77b92414&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77b92414",
  null
  
)

export default component.exports